import {Component, OnInit, OnDestroy} from '@angular/core';
import {UserService} from '../service/user.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {FormGroup} from '@angular/forms';
import {WholesaleService} from '../service/wholesale.service';
import {WholesaleConstants} from '../constants/wholesale.constants';
import {formatDate} from '@angular/common';
import {DomSanitizer} from '@angular/platform-browser';
import { GetAllocationMarketDataService } from '../service/get-allocation-market-data.service';
import { LoginService } from '../service/login.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	standalone: false,
	selector: 'app-home-page',
	templateUrl: './home-page.component.html',
	styleUrls: ['./home-page.component.css']
})

export class HomePageComponent implements OnInit, OnDestroy {

	public show = false;
	public unauthShow = false;
	public loading = true;
	public marketList: any[];
	public marketCodeShow = false;
	public dashBoardShow = false;
	public messageShow = false;
	public messageBody: any;
	public formHome: FormGroup;
	public unauthorizationForm: FormGroup;
	public errorMsg: string;
	public wholesaleCurrentMonth: any;
	public wholesaleLetter: any[];
	public isAuthorizedUser: boolean;
	public roleCode;
	public loggedInCdsId;
	public multipleMarketUsersList;
	private readonly _destroying$ = new Subject<void>();
	private initialized = false;

	constructor(
		private userService: UserService, 
		private router: Router,
		private translate: TranslateService, 
		private wholesaleService: WholesaleService, 
		private getAllocationMarketDataService: GetAllocationMarketDataService,
		private sanitizer: DomSanitizer,
		private loginService: LoginService
	) {
	}

	ngOnInit() {
		// Check if session is already initialized (both roleCode and marketCode must be present)
		if (sessionStorage.getItem('roleCode') && sessionStorage.getItem('loggedInUserMarketCode')) {
			this.initializeComponent();
		} else {
			// Wait for login service to signal that session is ready
			this.loginService.isLoggedIn$()
				.pipe(takeUntil(this._destroying$))
				.subscribe(isLoggedIn => {
					if (isLoggedIn && !this.initialized) {
						// Give a small delay to ensure session storage is populated
						setTimeout(() => {
							this.initializeComponent();
						}, 100);
					}
				});

			// Also set a timeout to check periodically for session initialization
			this.waitForSession();
		}
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}

	private waitForSession(): void {
		const checkSession = () => {
			// Wait for both roleCode AND loggedInUserMarketCode to be set
			if (sessionStorage.getItem('roleCode') && sessionStorage.getItem('loggedInUserMarketCode') && !this.initialized) {
				this.initializeComponent();
			} else if (!this.initialized) {
				setTimeout(checkSession, 200);
			}
		};
		setTimeout(checkSession, 200);
	}

	private initializeComponent(): void {
		if (this.initialized) {
			return;
		}
		this.initialized = true;
		this.loading = false;

		this.authoriseUser();
		this.getAllocationMarketDataService.getMarketList().subscribe((response: any[]) => {
			this.marketList = response;
		});
		this.loggedInCdsId = (sessionStorage.getItem('cdsId') || '').toLowerCase();

		this.wholesaleCurrentMonth = this.transformDate(new Date(), WholesaleConstants.dateFormatYYYYMM);
		this.getAllocationMarketDataService.getMulitpleMarketUsersList().subscribe((response: any[]) => {
			this.multipleMarketUsersList = response;
			if (this.multipleMarketUsersList && this.multipleMarketUsersList[this.loggedInCdsId]) {
				this.marketCodeShow = true;
				this.marketList = this.multipleMarketUsersList[this.loggedInCdsId];
			}
		});
		this.wholesaleService.getMessage(this.wholesaleCurrentMonth).subscribe((response: any[]) => {
			this.wholesaleLetter = response;
			if (this.wholesaleLetter && this.wholesaleLetter.length !== 0) {
				this.messageShow = true;
				this.messageBody = this.sanitizer.bypassSecurityTrustHtml(this.wholesaleLetter[0].messageBody);
			}
		});

		this.roleCode = sessionStorage.getItem('roleCode');
		if (this.roleCode === '4' || this.roleCode === '5') {
			this.marketCodeShow = true;
		}
		if (this.roleCode === '1' || this.roleCode === '4' || this.roleCode === '5') {
			this.dashBoardShow = true;
		}
	}

	public onMarketCodeSelect(marketCode: any) {
		sessionStorage.setItem('loggedInUserMarketCode', marketCode);
		const marketText = this.marketList.filter(
			data => data.value === marketCode
		)[0].label;
		sessionStorage.setItem('loggedInUserMarketText', marketText);
		this.loginService.marketChanged.next(marketText);
		this.router.navigate(['/wholesale-by-zone']);
	}

	authoriseUser() {
		this.isAuthorizedUser = this.userService.isAuthorisedUser();
		if (!this.isAuthorizedUser) {
			this.unauthShow = true;
		} else {
			this.show = true;
		}
	}

	public transformDate(date: string | number | Date, pattern: string) {
		return formatDate(date, pattern, 'en-US');
	}

}
